import React from "react"
import { SentTextIcon, NoteBookIcon, PhoneIcon } from "./../../assets"

// export const CONTACTS_INFO=[]

export const CONTACTS_INFO=[
  {
    id:1,
    name:"George Jamison",
    campaign:"Fresno Investor",
    active:true,
    phone:"+1 916 236 5845",
    email:"george.jamison@email.com",
    address:"30 North Street Southribdge, MA 01550",
    history:[
      {
        type:"call",
        date:"2023-03-14T11:50:28.424",
        from:"+1781492770"
      },
      {
        type:"text",
        data:"Sorry I didn’t respond sooner, I have just been busy. Let’s set up a call!",
        date:"2023-03-14T11:50:28.424",
        from:"+1781492770"
      },
      {
        type:"note",
        data:"I spoke face to face with George and he said that he’ll talk to his wife about what we discussed.",
        date:"2023-03-14T11:50:28.424",
        from:"+1781492770"
      },
      {
        type:"call",
        date:"2023-03-12T12:13:32.066Z",
        from:"+1781492770"
      },
      {
        type:"text",
        data:"Yesterday Sorry I didn’t respond sooner, I have just been busy. Let’s set up a call!",
        date:"2023-03-12T12:13:32.066Z",
        from:"+1781492770"
      },
      {
        type:"note",
        data:"Yesterday, I spoke face to face with George and he said that he’ll talk to his wife about what we discussed.",
        date:"2023-03-12T12:13:32.066Z",
        from:"+1781492770"
      }
    ]
  },
  {
    id:2,
    name:"Debbie Richardson",
    campaign:"Folsom",
    active:false,
  },
  {
    id:3,
    name:"Bryan McDaniels",
    campaign:"Folsom",
    active:false,
  },
  {
    id:4,
    name:"Bruce Harrington",
    campaign:"Folsom",
    active:true,
    phone:"+1 916 236 5845",
    email:"debbie.richardson@email.com",
    address:"30 Debbie Street New York, MA 01550",
    history:[
      {
        type:"call",
        date:"2023-03-14T11:50:22.424",
        from:"+1636474777"
      },
      {
        type:"text",
        data:"Hey, Let’s set up a call! Need to have a discussion with you.",
        date:"2023-03-14T11:50:22.424",
        from:"+1636474777"
      },
      {
        type:"note",
        data:"Just Meet with the Guy from IT department",
        date:"2023-03-14T11:50:22.424",
        from:"+1636474777"
      }
    ]
  },
  {
    id:5,
    name:"Stevie Wonder",
    campaign:"Folsom",
    active:true,
    phone:"+1 916 236 5845",
    email:"george.jamison@email.com",
    address:"30 North Street Southribdge, MA 01550",
    history:[]
  },
  {
    id:6,
    name:"Harry Richards",
    campaign:"Folsom",
    active:false,
  },
  {
    id:7,
    name:"Lacie Johnson",
    campaign:"Folsom",
    active:false,
  },
  {
    id:8,
    name:"Trudy Wilson",
    campaign:"Folsom",
    active:false,
  }
]

export const BUTTONS_DATA=[
  {
    icon: <PhoneIcon/>,
    text:"New Call"
  },
  {
    icon: <SentTextIcon/>,
    text:"Send Text"
  },
  {
    icon: <NoteBookIcon/>,
    text:"Add Note"
  },
]

export const DROPDOWN_DATA=[
  {name:"Sent Welcome Email",value:"Sent Welcome Email"},
  {name:"Sent Welcome",value:"Sent Welcome"}
]

export const DROPDOWN_DATA_1=[
  {name:"Jessica Jones",value:"Jessica Jones"},
  {name:"Jessica",value:"Jessica"}
]

export const DISPOSITIONS = [
  { name: "", value: ""},
  { name: "App Taken", value: "AppTaken"},
  { name: "Call Back", value: "CallBack"},
  { name: "Do Not Call", value: "DoNotCall"},
  { name: "Hang Up", value: "HangUp"},
  { name: "Left Voice Mail", value: "LeftVoiceMail"},
  { name: "No Answer", value: "NoAnswer"},
  { name: "Not Interested", value: "NotInterested"},
  { name: "Scheduled Viewing", value: "ScheduledViewing"},
  { name: "Sent Welcome Email", value: "SentWelcomeEmail"},
  { name: "Wrong Number", value: "WrongNumber"},
]



// WEBPACK FOOTER //
// ./src/pages/next-action/data.tsx